window.FilterList = new function()
{
    this.init = function() {
        jQuery('.filter-list').on('keyup', 'input', function(event) {
            event.preventDefault();
            
            var search_val = jQuery(this).val();

            FilterList.filterResults(this, search_val);
        });
    };

    /**
     * Filter down the list to show results based on search value
     * 
     * @param string search_val
     */
    this.filterResults = function(el, search_val) {
        search_val = search_val.toLowerCase();
        var list   = jQuery(el).closest('.filter-list').find('ul');

        jQuery(list).find('li').hide();

        jQuery(list).find('li').each(function(index, el2) {
            var text = jQuery(el2).find('a').text();
            text     = text.toLowerCase();

            if(text.includes(search_val)) {
                jQuery(el2).show();
            }
        });
    };
}

jQuery(document).ready(function($) {
    FilterList.init();
});
